import Vue from 'vue'
import {
  formatNumber,
  alignCells,
  LinkCellRenderer,
  autoResize,
  MultiLinkCellRenderer,
  notificationsRenderer
} from '@/helpers/renderHelpers'
import gridProps from '@/gridProps'

const casualFetch = async ({
                             url,
                             commitWith,
                             store,
                             payload
                           }) => {
  try {
    const { data } = await Vue.http.get(url, payload)
    store.commit(commitWith, data)
  } catch (e) {
    console.log(e)
  }
}
const defaultGrid = {
  grid_name: '',
  used_columns: [],
  data: [],
  total: 0,
  count: 0
}
const updateDataFor = ({
                         data, gridName, state
                       }) => {
  Object.keys(state[gridName]).forEach((key) => {
    Vue.set(state[gridName], key, data[key])
  })
  if (!Array.isArray(data.data)) {
    Vue.set(state[gridName], 'data', data.data.results)
    Vue.set(state[gridName], 'total', data.data.count)
    Vue.set(state[gridName], 'count', data.data.results.length)
  }
}

export default {
  namespaced: true,
  state: {
    gridOptions: {
      // getNodeChildDetails: getNodeChildDetails,
      rowSelection: 'multiple',
      groupSelectsChildren: true,
      rowGroupPanelShow: 'always',
      onRowDataChanged () {
        if (this.rowData && this.rowData.length) {
          autoResize(this)
        } else {
          this.api && this.api.hideOverlay()
          this.api && this.api.showNoRowsOverlay()
        }
      },
      components: {
        'SalesInvoiceLink': LinkCellRenderer('id', '/sales-invoice/'),
        'BuyerLink': LinkCellRenderer('buyer_id', '/partners/'),
        'ShipmentLink': MultiLinkCellRenderer('children', '/operation/', 'movement_name', 'movement_id'),
        'SalesOrdersLinks': MultiLinkCellRenderer('sale_orders', '/sales-orders/', 'descriptor', 'id')
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        enableValue: true,
        enableRowGroup: true,
        valueFormatter (params) {
          return formatNumber(params.value)
        },
        cellStyle (params) {
          return {textAlign: 'left'};
        }
      }
    },
    searchPayload: {
      limit: 100,
      offset: 0
    },
    grid: { ...defaultGrid },
    approvedGrid: { ...defaultGrid },
    selected: []
  },
  getters: {
    approvalTabGridOptions (state) {
      return {
        ..._.cloneDeep(gridProps),
        ..._.cloneDeep(state.gridOptions)
      }
    },
    approvedTabGridOptions (state) {
      return {
        ..._.cloneDeep(gridProps),
        ..._.cloneDeep(state.gridOptions)
      }
    }
  },
  mutations: {
    setApprovalTabData (state, data) {
      updateDataFor({
        state, data, gridName: 'grid'
      })
    },
    setApprovedTabData (state, data) {
      updateDataFor({
        state, data, gridName: 'approvedGrid'
      })
    },
    setSelected (state, data) {
      state.selected = data
    }
  },
  actions: {
    async loadApprovalTab (store, payload) {
      await casualFetch({
        store,
        payload,
        url: 'accounting/invoices_approval/',
        commitWith: 'setApprovalTabData',
      })
    },
    async loadApprovedTab (store, payload) {
      await casualFetch({
        store,
        payload,
        url: 'accounting/sent_invoices/',
        commitWith: 'setApprovedTabData',
      })
    },
    setSelected (store, payload) {
      store.commit('setSelected', payload)
    },
    async billInvoices (store) {
      try {
        const { data } = await Vue.http.post('accounting/invoices_approval/', {
          invoices: store.state.selected
        })
        const entries = Object.entries(data)

        if (entries.every(([_, value]) => !value.length)) {
          notificationsRenderer('successfully billed invoices', 'success')
        } else {
          notificationsRenderer('Some invoices weren\'t billed!', 'error')
          entries.forEach(([error, invoiceNumbers]) => {
            if (invoiceNumbers.length) {
              // todo translations?
              notificationsRenderer(`For invoice numbers ${invoiceNumbers.join(', ')}: ${error}`, 'error')
            }
          })
        }
        store.commit('setSelected', [])
      } catch (e) {
        console.log(e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sales/invoices-approval/invoicesApproval.js